import axios from "axios";

let URL = window.$global_app_url || 'https://sanfer.areaseisdesarrollo.com'

const instance = axios.create({
  baseURL: `${URL}/api`
});

export default instance;
